import { Component, OnInit } from '@angular/core';
import { ReservationModel } from "../../../models/reservations/reservation.model";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { GetReservationsByUserRequestModel } from "../../../models/reservations/get-reservations-by-user-request.model";
import { ReservationService } from "../../../services/reservations/reservation.service";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: 'app-approved-reservations',
  templateUrl: './approved-reservations.component.html',
  styleUrls: ['./approved-reservations.component.scss']
})
export class ApprovedReservationsComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public reservationList: Array<ReservationModel> = [];
  public paginationHelperModel: GetReservationsByUserRequestModel;
  public spinner: boolean = false;
  public totalPages: number;
  public totalRecords: number;
  //#endregion

  //#region Constructor
  constructor(
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private reservationService: ReservationService
  ) {
    if (this.config.data != undefined && this.config.data.model) {
      this.paginationHelperModel = this.config.data.model;
    }
  }

  ngOnInit(): void {
    this.getReservationsForUserEmail();
  }
  //#endregion

  //#region Public Methods
  getReservationsForUserEmail(): void {
    this.spinner = true;
    this.reservationService.getReservationsForUserEmail(this.paginationHelperModel)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response: any) => {
          this.totalPages = response.totalPages;
          this.totalRecords = response.totalRecords;
          if (this.paginationHelperModel.pageNumber > 1) {
            this.reservationList = this.reservationList.concat(response.data)
          }
          else {
            this.reservationList = response.data;
          }
          this.spinner = false;
        },
        error: errorResponse => {
          this.spinner = false;
        }
      });
  };

  loadMoreReservations(): void {
    this.paginationHelperModel.pageNumber = this.paginationHelperModel.pageNumber + 1;
    this.getReservationsForUserEmail();
  }
  //#endregion
}
